import { render, staticRenderFns } from "./NvDialog.vue?vue&type=template&id=0cb2507c&scoped=true&"
import script from "./NvDialog.vue?vue&type=script&lang=js&"
export * from "./NvDialog.vue?vue&type=script&lang=js&"
import style0 from "./NvDialog.vue?vue&type=style&index=0&id=0cb2507c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2507c",
  null
  
)

export default component.exports